import { observable, reaction } from 'mobx';
// import { autobind } from 'core-decorators';
import { useEffect } from 'react';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const pageLocalesData = getPageLocalesData();
import toWebpImage from '@src/utils/to-webp-image';
import { jumpPage } from '@src/utils/common-util';
import useFunLinkPageData from '@src/utils/use-fun-link-page-data.js';

class MapStore extends BaseStore {

  @observable
  mechaList = [];
  @observable
  meachaData = [];
  @observable meachaNameList = {
    inferno: {
      name: pageLocalesData.mecha_unit_list.mechaName7,
    },
    tricera: {
      name: pageLocalesData.mecha_unit_list.mechaName6,
    },
    welkin: {
      name: pageLocalesData.mecha_unit_list.mechaName5,
    },
    narukami: {
      name: pageLocalesData.mecha_unit_list.mechaName1,
    },
    serenith: {
      name: pageLocalesData.mecha_unit_list.mechaName2,
    },
    stellarus: {
      name: pageLocalesData.mecha_unit_list.mechaName3,
    },
    falcon: {
      name: pageLocalesData.mecha_unit_list.mechaName4,
    }
  }

  mechaSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      spaceBetween: 0,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 500,
      on: {
        slideChange() {
          // alert('改变了，activeIndex为' + this.activeIndex);
        }
      }
    }
  });
  versionTabSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: -20
      // loopedSlides: 3
    }
  });

  Lang() {
    if (getLanguageByPath() === 'zh-Hant') {
      return 'tc';
    } else {
      return getLanguageByPath();
    }
  }
  gounit(id) {
    // $$tracker.clickTzjxq();

    if (!IS_DEV_ENV) {
      const url = 'mecha-unit.html';
      jumpPage(url, `?id=${id}`);
    } else {
      this.redirect(`/mecha-unit?id=${id}`);
    }
  }

  use() {
    super.use();
    const data = useFunLinkPageData();
    useEffect(
      () => {
        if (!data) {
          return;
        }
        // console.log(data.mechaList);
        
        this.mechaList = data.mechaList.filter(item => Object.keys(this.meachaNameList).includes(item.mecha_id));
        // console.log();
        this.mechaList=[...this.mechaList]
        for (const item of this.mechaList) {
          item.ref = toWebpImage(require(`./images/${this.Lang()}/${item.mecha_id}/ref.png`))
          item.name = this.meachaNameList[item.mecha_id].name
          item.btn_more = toWebpImage(require(`./images/${this.Lang()}/btn-more.png`))
          item.driverName = toWebpImage(require(`./images/${this.Lang()}/${item.mecha_id}/driverName.png`))
        }
        this.meachaData = this.mechaList
      },
      [data]
    );
    useEffect(
      () => {
        this.mechaSwiper.activeIndex = this.versionTabSwiper.activeIndex;
        // console.log(this.mechaSwiper.activeIndex, this.versionTabSwiper.activeIndex, 111);

      },
      [this.versionTabSwiper.activeIndex]
    );
    useEffect(
      () => {
        this.versionTabSwiper.activeIndex = this.mechaSwiper.activeIndex;
        // console.log(this.mechaSwiper.activeIndex, this.versionTabSwiper.activeIndex, 222);
      },
      [this.mechaSwiper.activeIndex]
    );
  }
}

export default MapStore;
